import { render, staticRenderFns } from "./BookingBg.vue?vue&type=template&id=39797d1a&scoped=true"
import script from "./BookingBg.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingBg.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BookingBg.vue?vue&type=style&index=0&id=39797d1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39797d1a",
  null
  
)

export default component.exports